import React from 'react'
import { Box, Link, Space, TextBody } from '@ally/metronome-ui'

const NoActiveAccounts: React.FC = () => {
  return (
    <Box textAlign="center" py="md" border="1px solid" borderColor="slate-3">
      <Space mb="xxs">
        <TextBody tag="p" size="lg" weight="bold">
          No Active Vehicles
        </TextBody>
      </Space>
      <TextBody tag="p" size="md">
        You can’t view the details for your vehicle accounts anymore, but you
        can still view your profile.
      </TextBody>
      <Link
        to="/profile"
        text="View Profile and Settings"
        aria-label="View Profile and Settings"
      />{' '}
    </Box>
  )
}

export default NoActiveAccounts
